/* 🤖 this file was generated by script */
export const wiconMessageTextCircle01 = {
  name: 'message_text_circle_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9.5h4M8 13h7m-2.5 7a8.5 8.5 0 10-8.06-5.78c.11.32.17.48.18.6a.9.9 0 01-.03.33c-.03.12-.1.24-.24.5l-1.63 3.02c-.23.43-.35.65-.32.81.02.15.1.28.23.35.14.09.39.06.88.01l5.12-.52.3-.03a.9.9 0 01.19.03c.06.01.15.05.32.11.95.37 1.98.57 3.06.57z"/></svg>`,
};
